import { ReactElement } from 'react';
import HyphenatedText from '@components/HyphenatedText';

interface RadioProps {
  label?: string;
  inputKey: string;
  onChange: (key: string) => void;
  style?: React.CSSProperties;
  radioStyle?: React.CSSProperties;
  disabled?: boolean;
}

export const Radio = ({
  label,
  inputKey,
  onChange,
  style,
  radioStyle,
  disabled
}: RadioProps): ReactElement => {
  return (
    <button
      type="button"
      style={{
        ...style
      }}
      disabled={disabled}
      onClick={() => onChange(inputKey)}
    >
      <div
        style={{
          ...radioStyle
        }}
      ></div>
      {label && <HyphenatedText>{label}</HyphenatedText>}
    </button>
  );
};
